import { Step, StepLabel, Stepper, Typography } from "@mui/material"

/** Stepper das telas em passos dos totens: o pagamento do checkout e o "Finalizar pedido" do totem de pedidos. */
interface StepperPagamentoProps {
    rotulos: string[]
    ativo: number
    deitado: boolean
}

export default function StepperPagamento({ rotulos, ativo, deitado }: StepperPagamentoProps): JSX.Element {
    return (
        <Stepper
            activeStep={ativo}
            orientation={deitado ? 'vertical' : 'horizontal'}
            alternativeLabel={!deitado}
            aria-label="Etapas do pagamento"
            sx={{
                '& .MuiStepLabel-label': { fontSize: deitado ? '1.2rem' : '1.05rem', fontWeight: 600 },
                '& .MuiStepIcon-root': { fontSize: deitado ? 36 : 32 },
                ...(deitado ? { '& .MuiStepConnector-line': { minHeight: 40 } } : {}),
            }}
        >
            {rotulos.map((rotulo) => (
                <Step key={rotulo}>
                    <StepLabel>
                        <Typography variant={deitado ? 'h6' : 'subtitle1'} component="span">
                            {rotulo}
                        </Typography>
                    </StepLabel>
                </Step>
            ))}
        </Stepper>
    )
}
